export default "__VITE_ASSET__CigjkZuO__"